import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup } from '@angular/forms';
import { PermissionEnum } from '@app/core/enums/permissions.enum';
import { AbstractFieldBuilder } from '@app/shared/components/fields/abstract.field';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'text-field-builder',
  templateUrl: './text-field-builder.component.html',
  styleUrls: ['./text-field-builder.component.scss'],
  standalone: false
})
export class TextFieldBuilderComponent extends AbstractFieldBuilder<FormControl<string>> implements OnInit, AfterViewInit {
  public Permission = PermissionEnum;

  @ViewChild('inputField') public inputField: ElementRef;

  public ngOnInit(): void {
    this.form = new FormGroup({
      field: new FormControl(
        this.fieldInitValue,
        this.computeValidators(),
        this.computeAsyncValidators()
      )
    });
    // Initialise the field in the registry
    this.setFieldValue(this.fieldInitValue);
    this.setFieldInitialValue(this.fieldInitValue);
    this.getNextState();
  }

  public ngAfterViewInit(): void {
    this.setupHooks();
    this.form.controls.field.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(50),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((value) => {
      this.setFieldValue(value);
    });
  }

  public cancel(): void {
    this.form.controls.field.setValue(this.getFieldInitialValue());
    super.cancel();
  }

  /**
   * Set focus on the element
   */
  public focus(): void {
    if (this.focusable) {
      setTimeout(() => this.inputField.nativeElement.focus());
    }
  }
}
